var monriScript
export default {
  methods: {
    loadMonriScript(liveFlag, success = () => {}) {
      // console.log(publicKey)
      if (!monriScript) {
        monriScript = window.document.createElement('script')
        if (liveFlag) {
          monriScript.src = 'https://ipg.monri.com/dist/components.js'
        } else {
          monriScript.src = 'https://ipgtest.monri.com/dist/components.js'
        }
        monriScript.onload = () => {
          success && success()
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(monriScript, head.firstChild)
      } else {
        success && success()
      }
    }
  }
}
